import { el, clear } from "./dom.js";
import { MAG } from "./magazine/kit.js";
import { getGameLinks } from "../api/igdb.js";

// Store / platform links on a game (roadmap #36): Official site, Steam, GOG,
// Epic, PlayStation, Xbox, Nintendo… from IGDB. Hidden when there are none.
export function gameLinksRow(igdbId) {
	const chips = el("div", { style: { display: "flex", gap: "7px", flexWrap: "wrap" } });
	const wrap = el("div", { hidden: true, style: { padding: "10px 16px 0" } },
		el("div", { style: { fontFamily: "'Archivo', sans-serif", fontWeight: "900", fontSize: "8.5px", letterSpacing: ".14em", textTransform: "uppercase", color: MAG.dim, marginBottom: "6px" } }, "Get it / more"),
		chips);
	if (!igdbId) return wrap;
	getGameLinks(igdbId)
		.then((links) => {
			clear(chips);
			for (const l of links.slice(0, 8)) {
				chips.append(el("a", {
					href: l.url,
					target: "_blank",
					rel: "noopener noreferrer",
					style: {
						fontFamily: "'Archivo', sans-serif", fontWeight: "800", fontSize: "11px", textDecoration: "none",
						borderRadius: "999px", padding: "7px 12px", color: MAG.ink, background: "rgba(255,255,255,.07)", border: `1px solid ${MAG.line}`,
					},
				}, `${l.label} ↗`));
			}
			wrap.hidden = links.length === 0;
		})
		.catch(() => {});
	return wrap;
}
